export default __webpack_public_path__ + "media/images/react_icons/wheelchair-1223ead8468fce791e793cd0b94eb449.svg";